(() => {
  document.querySelectorAll('[data-catalogue-product]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-catalogue-json]').textContent);
    const primaryImages = JSON.parse(root.querySelector('[data-primary-images]').textContent);
    const select = root.querySelector('[data-model-select]');
    const mainImage = root.querySelector('[data-main-image]');
    const dialog = root.querySelector('[data-zoom-dialog]');
    let model = data.models.find(m => m.id === select.value) || data.models[0];
    let imageIndex = 0;
    function showImage(index) {
      imageIndex = (index + model.gallery.length) % model.gallery.length;
      mainImage.src = model.gallery[imageIndex];
      root.querySelector('[data-open-zoom]').href = mainImage.src;
      mainImage.alt = `${root.dataset.productName} - ${model.label} - ${imageIndex + 1}`;
      root.querySelector('[data-zoom-image]').src = mainImage.src;
      root.querySelector('[data-zoom-image]').alt = mainImage.alt;
      root.querySelector('[data-image-count]').textContent = `${imageIndex + 1} / ${model.gallery.length}`;
      root.querySelector('[data-zoom-caption]').textContent = `${model.label} (${imageIndex + 1} / ${model.gallery.length})`;
      root.querySelectorAll('[data-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumbnail) === imageIndex)));
    }
    function updateModel(id, updateHistory = true) {
      model = data.models.find(m => m.id === id) || data.models[0];
      select.value = model.id;
      root.querySelector('[data-variant-input]').value = model.id;
      root.querySelector('[data-reference-input]').value = model.ref;
      root.querySelector('[data-catalogue-price]').textContent = model.price;
      root.querySelector('[data-finish-note]').hidden = !model.confirmFinish;
      root.querySelector('[data-delivery-note]').hidden = model.available;
      root.querySelectorAll('[data-model-ref]').forEach(el => el.textContent = model.ref);
      root.querySelectorAll('[data-detail-model]').forEach(el => el.textContent = model.label);
      root.querySelectorAll('[data-add-cart]').forEach(button => button.disabled = !model.available);
      const thumbnails = root.querySelector('[data-thumbnails]');
      thumbnails.replaceChildren(...model.gallery.map((src, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.thumbnail = index;
        button.setAttribute('aria-label', `${data.galleryLabel} ${index + 1}`);
        const img = document.createElement('img');
        img.src = src; img.alt = ''; img.width = 88; img.height = 88; img.loading = 'lazy';
        button.append(img); return button;
      }));
      root.querySelector('[data-model-specs]').replaceChildren(...model.specs.map(spec => {
        const row = document.createElement('div'), label = document.createElement('dt'), value = document.createElement('dd');
        label.textContent = spec.label; value.textContent = spec.value; row.append(label, value); return row;
      }));
      root.querySelectorAll('[data-detail-image]').forEach(img => {
        img.src = model.details[Number(img.dataset.detailImage)] || model.gallery[0];
        img.alt = `${root.dataset.productName} - ${model.label} - ${data.galleryLabel}`;
      });
      root.querySelectorAll('[data-whatsapp-inquiry]').forEach(link => {
        const accessory = link.classList.contains('pdp-accessory-inquiry');
        const message = data.message.replace('__PRODUCT__', accessory ? data.accessoryName : root.dataset.productName).replace('__MODEL__', accessory ? '33-64 mm; 108 / 136 / 144' : `${model.label}; ${model.ref}`);
        const url = new URL(link.href);
        url.searchParams.set('text', `${message} ${root.dataset.productUrl}`);
        link.href = url.href;
      });
      root.querySelectorAll('[data-model-inquiry]').forEach(link => {
        const url = new URL(link.href); url.searchParams.set('variant', model.label); url.searchParams.set('reference', model.ref); link.href = url.href;
      });
      if (updateHistory) {
        const url = new URL(location.href); url.searchParams.set('variant', model.id); history.pushState({}, '', url);
      }
      showImage(primaryImages[model.id] || 0);
    }
    select.addEventListener('change', () => updateModel(select.value));
    window.addEventListener('popstate', () => updateModel(new URL(location.href).searchParams.get('variant'), false));
    root.querySelector('[data-thumbnails]').addEventListener('click', event => {
      const button = event.target.closest('[data-thumbnail]'); if (button) showImage(Number(button.dataset.thumbnail));
    });
    root.querySelector('[data-open-zoom]').addEventListener('click', event => { event.preventDefault(); showImage(imageIndex); dialog.showModal(); document.documentElement.classList.add('pdp-zoom-open'); });
    root.querySelector('[data-close-zoom]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('pdp-zoom-open'); root.querySelector('[data-open-zoom]').focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    dialog.addEventListener('keydown', event => { if (event.key === 'ArrowRight') { event.preventDefault(); showImage(imageIndex + 1); } if (event.key === 'ArrowLeft') { event.preventDefault(); showImage(imageIndex - 1); } });
    root.querySelectorAll('[data-image-step]').forEach(button => button.addEventListener('click', () => showImage(imageIndex + Number(button.dataset.imageStep))));
    updateModel(model.id, false);
  });
})();
